class ShareButton extends HTMLElement {
  constructor() {
    super();
    
    this.urls = {
      facebook: '//www.facebook.com/sharer/sharer.php?u=',
      twitter: '//twitter.com/intent/tweet?original_referer=&url=',
      pinterest: '//www.pinterest.com/pin/create/button/?url='
    };

    this.buttons = this.querySelectorAll('.share-button');
    this.pageUrl = window.location.href;

    this.buttons.forEach(button => {
      button.addEventListener('click', e => {
        e.preventDefault();

        let type = button.getAttribute('js-social');
        let url = this.urls[type];

        this.openShareWindow(url, type, button);
      });
    });
  }

  openShareWindow(url, type, button) {
    const params = 'width=800, height=600, toolbar=no, scrollbars=no, location=no, menubar=no, resizable=no';
    const target = type === 'pinterest' ? "pinIt" : `${type}-share-dialog`;
    
    let media;
    let desc;

    if (this.type !== 'pinterest') {
      media = button.getAttribute('js-image');
      desc = button.getAttribute('js-description');
    }

    window.open(url + this.pageUrl + '&media=' + media + "&description=" + desc, target, params);
  }
}

customElements.define('share-button', ShareButton);